<template>
  <div>
    <charts-app
      :fetch="fetch"
      :defaultData="defaultData"
      :replaceFormItem="item"
    ></charts-app>
  </div>
</template>

<script>
import aiFriendManageApi from "../../../api/aiFriendManage";
import mixinRolePicker from "../mixins/mixinRolePicker";
import ChartsApp from "./app.vue";

export default {
  components: { ChartsApp },
  name: "AiFriendRoleChart",
  mixins: [mixinRolePicker],
  computed: {
    fetch() {
      return aiFriendManageApi.getRoleRealtimeImage;
    },
    defaultData() {
      return {
        appId: null,
        roleId: null,
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
